<template>
  <div
    class="footer container"
    :style="{ display: 'flex', marginBottom: '5rem' }"
  >
    <div
      :style="{
        display: 'flex',
        gap: '2rem',
        flexGrow: '1',
        flexWrap: 'wrap',
      }"
    >
      <div class="_column">
        <img
          src="/logo.svg"
          :style="{ maxWidth: '12rem' }"
        >
      </div>
      <div class="_column">
        <h4>Product</h4>
        <div class="_item">
          <router-link :to="{ name: $routes.pricing }">
            Pricing
          </router-link>
        </div>
        <div class="_item">
          <a
            target="_blank"
            href="https://tally.so/r/3NloWW"
          >
            Feedback
          </a>
        </div>
      </div>
      <div class="_column">
        <h4>Company</h4>
        <div class="_item">
          <router-link :to="{ name: $routes.privacyPolicy }">
            Data privacy
          </router-link>
        </div>
        <div class="_item">
          <router-link :to="{ name: $routes.legalNotice }">
            Legal Notice
          </router-link>
        </div>
        <div class="_item">
          <router-link :to="{ name: $routes.termsOfUse }">
            Terms of use
          </router-link>
        </div>
      </div>
      <div class="_column">
        <h4>Contact</h4>
        <div class="_item">
          <a mailto="help@notix.so">help@notix.so</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { name: 'WebsiteFooter' };
</script>

<style scoped lang="scss" type="text/scss">
.footer {
  h4 {
    margin: 1rem 0;
  }

  a {
    text-decoration: none;
  }

  ._item {
    margin: 1rem 0;
  }

  ._column {
    flex: 1 1 20rem;
  }
}
</style>
